import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    hasImage,
    isTrueFalse,
    removeFirstAndLastThreeChars,
    replaceMathTagWithAltText,
} from "../Component/utils/helper";
import { useNavigate } from "react-router-dom";
import moment from "moment/moment";
import { CustomModal } from "./customModel";
import EditModel from "./EditModel";
import { setPaperData } from "../redux/actions/paperDataAction";
import { PDFDocument, rgb, degrees, StandardFonts } from 'pdf-lib';
import axios from "axios";
import { config } from "../Api/config";



const PdfPreview = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const examData = useSelector((state) => state?.PaperData?.PaperData);
    const [isModelOpen, setisModelOpen] = useState(false);
    const [fontSize, setFontSize] = useState(examData?.font_size || 18);
    const [headingTextSize, setHeadingTextSize] = useState(
        examData?.heading_size || 22
    );
    const [watermarkItemSize, setWatermarkItemSize] = useState(
        examData?.watermark_size || 25
    );
    const [watermarkItemOpacity, setWatermarkItemOpacity] = useState(
        examData?.watermark_opacity || 50
    );
    const [modifiedPdfUrl, setModifiedPdfUrl] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const fontFamily = ["Arial", "Courier New"];
    const overAllFontSize = examData?.font_size || 18;
    const headingSize = examData?.heading_size || 22;
    const watermarkSize = examData?.watermark_size || 25;
    const watermarkOpacity = examData?.watermark_opacity || 50;

    const paperType = examData?.paperType;

    const isExamPaperExamdate =
        (examData?.paperType === 0 || examData?.paperType === 1) &&
        examData?.exam_date;

    const isWithSection = examData?.genrate_type == "with section" ? true : false;

    const htmlContentDemo = `
    <html>
    <head>
      
    <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Exam Paper</title>
      <script src="https://polyfill.io/v3/polyfill.min.js?features=es6"></script>
      <script id="MathJax-script" async src="https://cdn.jsdelivr.net/npm/mathjax@3/es5/tex-mml-chtml.js"></script>
  
  
      <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/katex@0.16.9/dist/katex.min.css" integrity="sha384-n8MVd4RsNIU0tAv4ct0nTaAbDJwPJzDEaqSD1odI+WdtXRGWt2kTvGFasHpSy3SV" crossorigin="anonymous">
      <script src="https://polyfill.io/v3/polyfill.min.js?features=es6"></script>
        <script id="MathJax-script" async
                src="https://cdn.jsdelivr.net/npm/mathjax@3/es5/tex-mml-chtml.js">
        </script>
    
        <style>
         
         body {
          }
          
          .body-class {
            font-family: ${fontFamily};
        }
  
        @page {
            padding: 20px 5px;
          
          }
        @media print {
          * {
              animation: none !important;
              transition: none !important;
            }
        }
         h1, h2, h3, h4, h5, h6 {
          color: #000000;
          font-family: ${fontFamily};
          font-size: ${overAllFontSize}px;
          margin: 4px;
        }
        ol, ul {
          list-style: none;
          padding: 0px;
          margin: 0px;
          font-family: ${fontFamily};
        }
        li {
          margin-bottom: 4px;
          font-family: ${fontFamily};
        }
        .exam-title {
          color: #000000;
          align-self: center;
          display: flex;
          font-family: ${fontFamily};
          font-size: ${overAllFontSize}px;
          margin: 0px;
        }
        .center-div {
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .parent {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        .random_genrate_notice {
          font-size: ${overAllFontSize}px;
          font-weight: bold;
          color: #000000;
          font-family: ${fontFamily};
          padding: 4px; 
          margin: 0 0 0 -10px;
        }
        p {
          font-family: ${fontFamily} !important;
          font-size: ${overAllFontSize}px !important;
          margin: 4px 0 ;
          padding: 4px 0 ;
          text-align: justify;
        }
       
        td, th {
          font-family: ${fontFamily} !important;
          font-size: ${overAllFontSize}px !important;
        }
        div {
          font-family: ${fontFamily} !important;
          font-size: ${overAllFontSize}px !important;
        }
        span {
          font-family: ${fontFamily} !important;
          font-size: ${overAllFontSize}px !important;
        }
        .options {
          display: flex;
          flex-wrap: wrap;
          font-family: ${fontFamily};
          font-size: ${overAllFontSize}px;
          padding: 0 0 0 20px;
          margin: 5px 0 0 0;
        }
        .option {
          width: 100%; /* Adjust as needed */
  
        }
        table[border="1"] {
          border: 1px solid black; /* Apply the border styling */
          border-collapse: collapse; /* Make sure borders do not double */
        }
  
        table[border="1"] td {
          border: 1px solid black; /* Apply border styling to table cells */
        }
  
        table[border="0"] td {
          border: 0px solid black; /* Apply border styling to table cells */
        }
        .question-container {
          display: flex;
          width: 100%;
          border-collapse: collapse;
          margin-bottom: 0 0 4px 0;
          padding: 0 0;
  
        }
        .question-column  {
          width: 40%;
          border: 1px solid #000;
          box-sizing: border-box ;
          font-family: ${fontFamily};
          font-size: ${overAllFontSize}px;
          background-color: #ffffff;
          margin: 0 0 0 0;
          padding: 0 0 0 0;
          
        }
        .question-column .pppp {
          
          text-align: center; 
          alingn-items: center;
          padding: 0 1px 0 1px !important; 
        }
        .answer-column  {
          width: 20%;
          border: 1px solid #000;
          box-sizing: border-box ;
          font-family: ${fontFamily};
          font-size: ${overAllFontSize}px;
          background-color: #ffffff;
          margin: 0 0 0 0;
          padding: 0 0 0 0;
        }
        .answer-column .pppp {
          
          text-align: center; 
          alingn-items: center;
          padding: 0 1px 0 1px !important; 
        }
        .last-message{
          color: #444444;
          font-size: 30px !important;
          display: flex;
          align-items: center;
          justify-content: center;
          margin:24px 0 0 0 ;
          font-family: 'Sofia', sans-serif
        }
  
  
      </style>
    </head>
    <body>
    <div class="body-class">
        <div style="display: flex; align-items: center;  flex-direction: column; justify-content: center;">
          ${examData?.institute_logo
            ? `
            <img src="${examData?.institute_logo}" alt="Logo" style="width: 40rem; height: 6rem; margin-bottom: 8px; " />
          `
            : `
            <h1 style="color: 'red'; margin-bottom: 0px; font-size: ${headingSize}px; display:flex; flex:1; text-align:center; justify-content: center; width: 90%;">${examData.school_name}</h1>
          `
        }
      </div>
      
      <hr>
      <div>
        <div class="parent">
        <p class="exam-title">Subject: ${examData?.subject_name}</p>
        ${examData?.exam_name &&
        `<p class="exam-title"> ${examData?.exam_name}</p>`
        }
        ${isExamPaperExamdate
            ? `<p class="exam-title" id="subject-name">Date: ${moment(
                examData?.exam_date
            ).format("DD-MM-YYYY")}</p>`
            : ``
        }
         
      </div>
        <div class="parent">
        <p class="exam-title">Standard: ${examData?.standard_name}</p>
         
      ${examData.exam_marks
            ? `<p class="exam-title" id="subject-name">Marks: ${examData.exam_marks?.length == 1
                ? "0" + examData.exam_marks
                : examData.exam_marks
            }</p>`
            : ``
        }
      </div>
      <div class="parent">
      ${examData.chapter_name &&
        `
      <p class="exam-title">Chapter: ${examData.chapter_name}</p>
      `
        }
      ${examData?.exam_time?.trim() && examData?.exam_time != undefined
            ? `
        <p class="exam-title" id="subject-name">Exam Time: ${examData?.exam_time}</p>
        `
            : ""
        }
     
      </div>
      </div>
  
      <hr>
      ${examData?.sections_info
            ?.map(
                (section) => `<section>
          ${isWithSection && section.section_name
                        ? `<div style="display: flex; align-items: center; justify-content: center;">
          
          <h2 style="text-align: center; text-decoration: underline; font-family: ${fontFamily}; font-size: ${overAllFontSize}px">${section.section_name}</h2>
          </div>`
                        : ""
                    }
        
        ${section?.divisions
                        ?.map(
                            (division) =>
                                `
          <div style="display: flex; justify-content: space-between; align-items: center; flex-direction: row; padding: 0px; margin: 0px" >
          ${!division?.random_genrate_notice
                                    ? ""
                                    : `<div style='display:flex; flex-direction:row'>
          <p class="random_genrate_notice">\u2023 &nbsp;</p>
          <p class="random_genrate_notice">${division.questionTitle ? division.questionTitle : ""
                                    } ${division.questionTitle ? "-" : ""} ${division.random_genrate_notice
                                    }</p>
          </p> 
          </div>
          <p style="font-size: ${overAllFontSize}px padding: 0 0 0 0; margin: 0 0 0 0">(${division.marks.length == 1
                                        ? "0" + division.marks
                                        : division.marks
                                    })</p> 
          `
                                }
          </div>
          ${!division?.random_genrate_notice
                                    ? ""
                                    : `
              <div style="min-height: fit-content; padding: 0 0 0 0; margin: 0 0 0 0">
          <ol>
            ${division?.question_data
                                        ?.map((question, _index) => {
                                            // if (question.isOr) {
                                            //   orIndex += 1;
                                            // }

                                            const getAnswers = () => {
                                                const indexOfAnswer = question?.finalAnswers?.findIndex(
                                                    option =>
                                                        option.imgAnswers == question?.finalAnswer ||
                                                        option.answer == question?.finalAnswer,
                                                );
                                                if (
                                                    question?.finalAnswers?.some(
                                                        (answer) => answer.imgAnswers == question?.finalAnswer
                                                    )
                                                ) {
                                                    return `<img src="${question?.finalAnswer}" alt="" style="max-width: 70px; max-height: 80px; margin: 0 5px" resize="contain"/>`;
                                                }
                                                return `
                     ${`(${String.fromCharCode(indexOfAnswer + 65)}) ${question?.finalAnswer
                                                    }`}
                    ${question?.finalAnswers.filter(
                                                        (answer) =>
                                                            answer.answer == question?.finalAnswer &&
                                                            answer.imgAnswers
                                                    ).length > 0
                                                        ? question?.finalAnswers
                                                            ?.filter(
                                                                (answer) => answer.answer == question?.finalAnswer
                                                            )
                                                            .map((answer) => {
                                                                return `
                          <img src="${answer?.imgAnswers}" alt="" style="width: 70px; height: 80px;" resize="contain"/>`;
                                                            })
                                                            .join("")
                                                        : ""
                                                    }
                   
                    `;
                                                // return `<img src="${question?.finalAnswer}" alt="" style="width: 70px; height: 80px;" resize="contain"/>`;
                                            };

                                            const question_id =
                                                question?.question_id > 0 && (question?.andId || 0) <= 1
                                                    ? `${Number(question?.question_id)
                                                        .toString()
                                                        .padStart(2, '0')}.${question?.andId
                                                            ? `&nbsp;(${String.fromCharCode((question?.andId || 0) + 96)})`
                                                            : ''
                                                    }`
                                                    : question?.question_id > 0
                                                        ? `(${String.fromCharCode((question?.andId || 0) + 96)})`
                                                        : `${paperType == 2
                                                            ? `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;`
                                                            : question?.question_id == 0 && _index > 99
                                                                ? `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;`
                                                                : `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;`
                                                        }`;

                                            let maxLength = question.finalAnswers
                                                ? Math.max(
                                                    ...question.finalAnswers.map((obj) => {
                                                        const regex = /^[a-zA-Z0-9]+$/;

                                                        const text = replaceMathTagWithAltText(obj.answer);

                                                        if (regex.test(text)) {
                                                            return text?.length;
                                                        }
                                                        return text?.length / 1.5;
                                                    })
                                                )
                                                : 0;

                                            let optionWidth = maxLength > 25 ? "100%" : "50%";

                                            return `
                ${(question?.questionLeft || question?.questionRight) &&
                                                    !question.paragraph
                                                    ? ""
                                                    : question?.isOr
                                                        ? `<p style="font-size: ${overAllFontSize}px; display: flex; align-items: center; justify-content: center; margin:0; padding:0 0 6px 0;">OR</p>`
                                                        : ""
                                                }
              <li style="${question?.questionLeft ? "margin: 0px" : ""}">
              ${question?.paragraph
                                                    ? `<p style="padding: 0 0 5px 35px; margin:0; text-align: justify;">${removeFirstAndLastThreeChars(
                                                        question?.paragraph
                                                    )}</p>`
                                                    : ""
                                                }
              ${question?.questionLeft || question?.questionRight
                                                    ? `
  
  
  
                  ${(question?.questionLeft || question?.questionRight) &&
                                                        question?.paragraph
                                                        ? `<div class="question-container">
                  
                  ${false
                                                            ? ""
                                                            : `
                  <p style="padding-right: 7px">${question?.question_id > 99
                                                                ? `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;`
                                                                : `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;`
                                                            }</p>`
                                                        }
                  <div class="question-column">
                  <p class="pppp" >A</p>
                   
                  </div>
                  <div class="question-column">
                  <p class="pppp">B</p>
                  </div>
  
  
                  ${paperType == 2 && question?.rightAnswer
                                                            ? `
                  <div class="answer-column">
                  <p class="pppp">Answer</p>
                  </div>
                  `
                                                            : ""
                                                        }
                </div>`
                                                        : ""
                                                    }
  
  
  
  
  
  
                  <div class="question-container">
                  
                  ${question.isOr
                                                        ? ""
                                                        : `
                  <p style="padding-right: 7px">${question_id}
                                    </p>`
                                                    }
                  <div class="question-column">
                  ${question?.questionLeft
                                                        ? `<p style="padding-left: 8px">${question?.questionLeft}</p>`
                                                        : ``
                                                    }
                  </div>
                  <div class="question-column">
                  ${question?.questionRight
                                                        ? `<p style="padding-left: 8px">${question?.questionRight}</p>`
                                                        : ""
                                                    }
                  </div>
  
  
                  ${paperType == 2
                                                        ? `
                  <div class="answer-column">
                  ${question?.questionRight && question?.rightAnswer
                                                            ? `<p style="padding-left: 8px"; class="pppp">${paperType == 2
                                                                ? question?.rightAnswer
                                                                : question?.questionRight
                                                            }</p>`
                                                            : ""
                                                        }
                  </div>
                  `
                                                        : ""
                                                    }
                </div>
              `
                                                    : `<div style='display:flex; flex-direction:row; margin: 0 0 0 ${question?.andId > 1 ? `${overAllFontSize + 8}px` : "0"
                                                    }'>
                  <p style="
                    padding: 0 0 0 ${question?.subID ? "5px" : "0"};
                    margin: 0 0 0 ${question?.subID ? "5px" : "0"};
                    ${paperType == 2 ? "font-weight: 700" : ""}
                  ">
               
                  ${question_id}</p>
                  <div style='padding :0 0 0 0; margin: 0 0 0 5px;  ${paperType == 2 ? "font-weight: 700" : ""
                                                    }'>
                
  
                  <p style='padding : 0 ; margin: 0;  font-size: ${overAllFontSize}px ${paperType == 2 ? "font-weight: 700" : ""
                                                    }'>
                  ${question?.qtype != 1 ||
                                                        hasImage(question?.finalquestion || question?.question)
                                                        ? removeFirstAndLastThreeChars(
                                                            question?.finalquestion || question?.question
                                                        )
                                                        : removeFirstAndLastThreeChars(
                                                            question?.finalquestion || question?.question
                                                        )
                                                            ?.replace(/<br>/g, "")
                                                            ?.replace(/</g, "&lt")
                                                            ?.replace(/>/g, "&gt")

                                                    // .replace(/\\/g, ``)
                                                    }
                    </p>
                  </div>
              </div>
                    `
                                                }
                ${question?.finalAnswers?.length > 0
                                                    ? `
                <ol class="options" >
             
             
  
  
  
                    ${(question?.finalAnswers?.[0]?.answer
                                                        ? question?.finalAnswers
                                                        : question?.answers
                                                    )

                                                        .map((answer, index) => {
                                                            return `
                        <div style='display:flex; justify-content:space-between; align-items:flex-start; width: ${optionWidth}; flex : ${maxLength < 15 ? 1 : undefined
                                                                }'>
                          <li style="margin:0 5px">${String.fromCharCode(
                                                                    65 + index
                                                                )}.&nbsp;</li>
                          <li class="option" style="display:flex;flex-direction:row;"> ${
                                                                // question.html_tag == 1 ||
                                                                // (question?.html_question == 1 &&
                                                                question.qtype != 1 || hasImage(answer?.answer || "")
                                                                    ? removeFirstAndLastThreeChars(answer?.answer || "")
                                                                    : removeFirstAndLastThreeChars(answer?.answer || "")
                                                                        ?.replace(/<br>/g, "")
                                                                        ?.replace(/</g, "&lt")
                                                                        ?.replace(/>/g, "&gt")
                                                                }
                         ${answer?.imgAnswers
                                                                    ? `<img src="${answer?.imgAnswers}" style="max-width: 70px; max-height: 80px; margin:0 4px" resize="contain"/>`
                                                                    : ""
                                                                } </li>
                        </div>
                      `;
                                                        })
                                                        .join("")}
  
  
              
                    
                </ol>
              `
                                                    : ""
                                                }
                ${paperType == 2
                                                    ? `
                  ${!(question?.questionLeft || question?.questionRight)
                                                        ? `
                      <div style='display:flex; flex-direction:row'>
                 <p style=' margin: 4px 0 4px 0;'>
                  <span style="font-weight: 700">
                  Ans. 
                  </span>
                  </p>
                  ${question?.qtype != "12"
                                                            ? `
                      <div style="">
                  <p style="text-align: justify;  margin: 4px 0 4px 0;  flex-direction:row;"> &nbsp;
                  ${question?.qtype == "1"
                                                                ? getAnswers()
                                                                : question?.qtype != "1" || hasImage(question?.finalAnswer)
                                                                    ? removeFirstAndLastThreeChars(isTrueFalse(question))
                                                                    : removeFirstAndLastThreeChars(
                                                                        isTrueFalse(question)
                                                                            ?.replace(/</g, "&lt")
                                                                            ?.replace(/>/g, "&gt")
                                                                    )
                                                            // removeFirstAndLastThreeChars(isTrueFalse(question))
                                                            }
                  </p>
                  
                  </div>
                `
                                                            : ``
                                                        }
                  
  
                  </div>
                  ${question?.qtype == "12"
                                                            ? `<div>
  
                       ${question?.perfact_metch
                                                                .map((item, _index) => {
                                                                    return `
                      <div class="question-container">
                      <div class="question-column">
                      ${item?.finalquestion ? `<p>${item?.finalquestion}</p>` : ""
                                                                        }
                      
                      </div>
                      <div class="question-column">
                      ${item?.finalanswer ? `<p>${item?.finalanswer}</p>` : ""}
                      </div>
                    </div>
                      `;
                                                                })
                                                                .join("")}
                          </div>`
                                                            : ""
                                                        } 
                  `
                                                        : ``
                                                    }
                  `
                                                    : ``
                                                }
  
                ${paperType == 3 &&
                                                    !(question?.questionLeft || question?.questionRight)
                                                    ? `
                    <div>
                    <div style="display: flex; flex-direction: row;">
                    <div style="">
                      <h2>Ans</h2>
                    </div>
                    <div style="flex: 1; border-bottom: 1.5px dashed black" />
                  </div>
                  </div>
                <div style="margin-left: 40px">
                  ${question?.QtypeInfo?.worksheet_space > 1
                                                        ? `
                    ${Array.from({
                                                            length: Number(question?.QtypeInfo?.worksheet_space - 1),
                                                        })
                                                            .map(
                                                                (_, _index) => `
                    <div >
                    <div style="flex: 1; padding: 10px; border-bottom: 1.5px dashed black;" />
                    </div>
                    `
                                                            )
                                                            .join("")}
                  `
                                                        : ``
                                                    }
                  </div>
                  `
                                                    : ``
                                                }
  
              </li>
            `;
                                        })
                                        .join("")}
          </ol>
          </div>
          `
                                }
          `
                        )
                        .join("")}
      </section>
     
      `
            )
            .join("")}
  
       
  ${paperType == 1 || paperType == 3
            ? ` ${paperType == 1 || paperType == 3
                ? examData?.last_message &&
                `<p class="last-message">${examData?.last_message} </p>  `
                : ""
            }
        <div style="page-break-before: always;" />
  
        <div style="display: flex; align-items: center;  flex-direction: column; margin-top: 1px">
            <h1 style="margin-bottom: 0px; ">ANSWERS</h1>
      </div>
      
      <hr>
      <div>
      <div class="parent">
      <p class="exam-title">Subject: ${examData?.subject_name}</p>
      ${examData?.exam_name && `<p class="exam-title"> ${examData?.exam_name}</p>`
            }
  
      ${isExamPaperExamdate
                ? `<p class="exam-title" id="subject-name">Date: ${moment(
                    examData?.exam_date
                ).format("DD-MM-YYYY")}</p>`
                : ``
            }
       
    </div>
      <div class="parent">
      <p class="exam-title">Standard: ${examData?.standard_name}</p>
    ${examData?.exam_marks
                ? `<p class="exam-title" id="subject-name">Marks: ${examData.exam_marks?.length == 1
                    ? "0" + examData.exam_marks
                    : examData.exam_marks
                }</p>`
                : ``
            }
    </div>
    <div class="parent">
    ${examData?.chapter_name &&
            `
    <p class="exam-title">Chapter: ${examData?.chapter_name}</p>
    `
            }
    ${examData?.exam_time?.trim() && examData?.exam_time != undefined
                ? `
      <p class="exam-title" id="subject-name">Exam Time: ${examData.exam_time}</p>
      `
                : ""
            }
   
    </div>
      </div>
  
      <hr>
      ${examData?.sections_info
                ?.map(
                    (section) => `<section>
          ${isWithSection && section?.section_name
                            ? `<div style="display: flex; align-items: center; justify-content: center;">
          
          <h2 style="text-align: center; text-decoration: underline; font-family: ${fontFamily}; font-size: ${overAllFontSize}px">${section.section_name}</h2>
          </div>`
                            : ""
                        }
        
        ${section?.divisions
                            ?.map(
                                (division) =>
                                    `
          <div style="display: flex; justify-content: space-between; align-items: center; flex-direction: row; padding: 0px; margin: 0px" >
          ${!division.random_genrate_notice
                                        ? ""
                                        : `
          <p class="random_genrate_notice">\u2023 ${division.random_genrate_notice
                                        }</p> 
          <p style="font-size: ${overAllFontSize}px padding: 4px; margin: 4px">(${division.marks.length == 1
                                            ? "0" + division.marks
                                            : division.marks
                                        })</p> 
          `
                                    }
          </div>
          ${!division?.random_genrate_notice
                                        ? ""
                                        : `
          <ol>
            ${division?.question_data
                                            ?.map((question, _index) => {
                                                const getAnswers = () => {
                                                    const indexOfAnswer = question?.finalAnswers?.findIndex(
                                                        option =>
                                                            option.imgAnswers == question?.finalAnswer ||
                                                            option.answer == question?.finalAnswer,
                                                    );
                                                    if (
                                                        question?.finalAnswers?.some(
                                                            (answer) => answer.imgAnswers == question?.finalAnswer
                                                        )
                                                    ) {
                                                        return `<img src="${question?.finalAnswer}" alt="" style="max-width: 70px; max-height: 80px; margin: 0 4px" resize="contain"/>`;
                                                    }
                                                    return `
                    ${question?.qtype == '1' && !hasImage(question?.finalAnswer)
                                                            ? `(${String.fromCharCode(
                                                                indexOfAnswer + 65,
                                                            )}) ${removeFirstAndLastThreeChars(
                                                                isTrueFalse(question)
                                                                    ?.replace(/</g, '&lt')
                                                                    ?.replace(/>/g, '&gt'),
                                                            )}`
                                                            : `(${String.fromCharCode(indexOfAnswer + 65)}) ${question?.finalAnswer
                                                            }`
                                                        }
                    ${question?.finalAnswers?.filter(
                                                            (answer) =>
                                                                answer?.answer == question?.finalAnswer &&
                                                                answer?.imgAnswers
                                                        ).length > 0
                                                            ? question?.finalAnswers
                                                                ?.filter(
                                                                    (answer) => answer.answer == question?.finalAnswer
                                                                )
                                                                .map((answer) => {
                                                                    return `
                          <img src="${answer?.imgAnswers}" alt="" style="max-width: 70px; max-height: 80px;margin: 0 4px" resize="contain"/>`;
                                                                })
                                                                .join("")
                                                            : ""
                                                        }
                   
                    `;
                                                    // return `<img src="${question?.finalAnswer}" alt="" style="width: 70px; height: 80px;" resize="contain"/>`;
                                                };

                                                const question_id =
                                                    question?.question_id > 0 && (question?.andId || 0) <= 1
                                                        ? `${Number(question?.question_id)
                                                            .toString()
                                                            .padStart(2, '0')}.${(question?.andId || 0)
                                                                ? `&nbsp;(${String.fromCharCode((question?.andId || 0) + 96)})`
                                                                : ''
                                                        }`
                                                        : question?.question_id > 0
                                                            ? `(${String.fromCharCode((question?.andId || 0) + 96)})`
                                                            : `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;`;
                                                if (question?.question_id == 0) return ``;
                                                return `
                ${(question?.questionLeft || question?.questionRight) &&
                                                        !question.paragraph
                                                        ? ""
                                                        : question.isOr
                                                            ? `<p style="font-size: ${overAllFontSize}px; display: flex; align-items: center; justify-content: center; margin:0; padding:0;">OR</p>`
                                                            : ""
                                                    }
              <li style="${question?.questionLeft ? "margin: 0px" : ""}">
              <div style='display:flex; flex-direction:row; margin: 0 0 0 ${question?.andId > 1 ? `${overAllFontSize + 8}px` : "0"
                                                    }'>
              <p style="
                    padding: 0 0 0 ${question?.subID ? "5px" : "0"};
                    margin: 0 0 0 ${question?.subID ? "5px" : "0"};
                    font-size: ${overAllFontSize}px;
                  ">
               
                  ${
                                                    // (question?.questionLeft || question?.questionRight) &&
                                                    // !question.paragraph
                                                    //   ? ''
                                                    //   :
                                                    question_id
                                                    }</p><p style='padding : 0; margin: 0 0 0 5px'>
                  <div>
                  ${question?.qtype != "12"
                                                        ? `
                  <p style='padding : 0; margin: 0; font-size: ${overAllFontSize}px'>
                 ${
                                                        //  question.finalAnswers?.[0]?.answer ||
                                                        //  question?.answers?.[0]?.answer
                                                        //    ? (question.finalAnswers?.[0]?.answer
                                                        //        ? question.finalAnswers
                                                        //        : question.answers)[Number(question?.ans_option)]?.answer
                                                        //    :
                                                        //  removeFirstAndLastThreeChars(isTrueFalse(question))

                                                        question?.qtype == "1"
                                                            ? getAnswers()
                                                            : question?.qtype != "1" || hasImage(question?.finalAnswer)
                                                                ? removeFirstAndLastThreeChars(isTrueFalse(question))
                                                                : removeFirstAndLastThreeChars(
                                                                    isTrueFalse(question)
                                                                        ?.replace(/</g, "&lt")
                                                                        ?.replace(/>/g, "&gt")
                                                                )
                                                        }
  
               
                 </p>
                  `
                                                        : ``
                                                    }
                  </div>
                    </p> 
                    ${question?.qtype == "12"
                                                        ? `<div>
                        ${question?.perfact_metch
                                                            .map((item, _index) => {
                                                                return `
                      <div class="question-container">
                      <div class="question-column">
                      ${item?.finalquestion ? `<p>${item?.finalquestion}</p>` : ""
                                                                    }
                      
                      </div>
                      <div class="question-column">
                      ${item?.finalanswer ? `<p>${item?.finalanswer}</p>` : ""}
                      </div>
                    </div>
                      `;
                                                            })
                                                            .join("")}
                        </div>`
                                                        : ""
                                                    }
                </div>
              </li>
            `;
                                            })
                                            .join("")}
          </ol>
          `
                                    }
          `
                            )
                            .join("")}
      </section>
      `
                )
                .join("")}
  
        `
            : ""
        }
  ${examData?.last_message
            ? `<p class="last-message">${examData?.last_message}</p> `
            : ""
        }
  
    </div>
    </body>
    </html>
  `;

  const Loading = () => {
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1000]">
        <div className="loader"></div>
      </div>
    )
  }
  
  const loaderKeyframes = `
    @keyframes l3 {
      20% { background-position: 0% 0%, 50% 50%, 100% 50% }
      40% { background-position: 0% 100%, 50% 0%, 100% 50% }
      60% { background-position: 0% 50%, 50% 100%, 100% 0% }
      80% { background-position: 0% 50%, 50% 50%, 100% 100% }
    }
  `
  
  const loaderStyles = `
    .loader {
      width: 60px;
      aspect-ratio: 2;
      --_g: no-repeat radial-gradient(circle closest-side, #fff 90%, #0000);
      background: 
        var(--_g) 0% 50%,
        var(--_g) 50% 50%,
        var(--_g) 100% 50%;
      background-size: calc(100%/3) 50%;
      animation: l3 1s infinite linear;
    }
  `
  
  const styleTag = document.createElement('style')
  styleTag.textContent = loaderKeyframes + loaderStyles
  document.head.appendChild(styleTag)

    const getImageBase64 = async (imageUrl) => {
        try {
            const response = await fetch(`${config.baseURL}get-image-base64?url=${encodeURIComponent(imageUrl)}`);
            const data = await response.json();

            // Remove "data:image/*;base64," part if needed
            const base64 = data.base64?.split(',')[1]; // safely handle missing values

            return base64;
        } catch (error) {
            console.error('Error fetching base64 from backend:', error);
            return null;
        }
    };

    useEffect(() => {
        setIsLoading(true);
        generatePDF();
    }, [examData]);

    const handleDownload = async () => {
        const link = document.createElement('a');
        link.href = modifiedPdfUrl;
        link.download = `${examData?.subject_name}-${examData?.standard_name}-${'Youth Education'}-${new Date().getTime()}.pdf`;
        link.click();
    };

    const handleEdit = () => {
        setisModelOpen(!isModelOpen);
    };

    const handleModelClose = () => {
        setisModelOpen(!isModelOpen);
    };

    async function addPageNumbersToBlob(blob) {
        try {
            const arrayBuffer = await blob.arrayBuffer();
            const pdfDoc = await PDFDocument.load(arrayBuffer);
            const font = await pdfDoc.embedFont(StandardFonts.Helvetica);

            const isLink = examData?.waterMarkUrl?.includes('https://');

            let imageBytes

            if (isLink) {

                await getImageBase64(examData?.waterMarkUrl).then(base64 => {
                    if (base64) {
                        imageBytes = base64
                    }
                });

            }

            for (let i = 0; i < pdfDoc.getPageCount(); i++) {
                const page = pdfDoc.getPage(i);
                const { width, height } = page.getSize();
                const pageNumberText = `Page ${i + 1}`;
                const textWidth = font.widthOfTextAtSize(pageNumberText, 12);

                if (examData.isborder) {
                    page.drawRectangle({
                        x: 10,
                        y: 10,
                        width: width - 20,
                        height: height - 20,
                        borderWidth: 1,
                        borderColor: rgb(0, 0, 0),
                    });
                }

                if (examData.footerText) {
                    page.drawText(examData.footerText, {
                        x: 28,
                        y: 15,
                        size: 10,
                        font: font,
                        color: rgb(0, 0, 0),
                    });
                }

                if (examData?.waterMarkUrl) {
                    // console.log('PaperData?.waterMarkUrl-==-=-', PaperData?.waterMarkUrl);
                    const fontSize = 36; // Adjust as needed

                    if (isLink) {
                        let image;

                        try {
                            image = await pdfDoc.embedPng(imageBytes);
                        } catch (error) {
                            console.error(
                                'Failed to embed image as PNG. Trying JPG...',
                                error,
                            );
                        }

                        if (!image) {
                            try {
                                image = await pdfDoc.embedJpg(imageBytes);
                            } catch (error) {
                                console.error('Failed to embed image as JPG.', error);
                                return null;
                            }
                        }
                        const imgSize = watermarkSize * 3;
                        page.drawImage(image, {
                            x: (width - imgSize) / 2,
                            y: (height - imgSize) / 2,
                            width: imgSize,
                            height: imgSize,
                            opacity: watermarkOpacity / 100,
                        });
                    } else {

                        const textWidth = font.widthOfTextAtSize(examData?.waterMarkUrl, fontSize);
                        const textHeight = font.heightAtSize(fontSize);



                        let textwid = textWidth > (width / 2) ? textWidth / 2 : textWidth;

                        // Calculate position to center rotated text
                        const x = (width - textwid) / 2 + 30;
                        const y = (height - textHeight) / 2;



                        page.drawText(examData?.waterMarkUrl, {
                            x,
                            y,
                            size: +(watermarkSize * 1).toFixed(0),
                            font,
                            color: rgb(0, 0, 0),
                            opacity: watermarkOpacity / 100,
                            rotate: degrees(45),
                            maxWidth: width / 2,
                            lineHeight: 55,
                        });
                    }
                }

                if (examData?.isPageNumber) {
                    page.drawText(pageNumberText, {
                        x: width - textWidth - 25,
                        y: 15,
                        size: 10,
                        font,
                        color: rgb(0, 0, 0),
                    });
                }
            }

            const modifiedPdfBytes = await pdfDoc.save();
            return new Blob([modifiedPdfBytes], { type: 'application/pdf' });
        } catch (error) {
            console.error('Error adding page numbers:', error);
            throw error;
        }
    }

    const generatePDF = async () => {
        const htmlContent = htmlContentDemo;
        try {
            const response = await axios.post(`${config.baseURL}generate-pdf`, {
                html: htmlContent
            }, {
                responseType: 'blob', // Important for receiving PDF file
            });

            const originalBlob = new Blob([response.data], { type: 'application/pdf' });
            // const originalBlob = new Blob([htmlContent], { type: 'application/pdf' });


            const modifiedBlob = await addPageNumbersToBlob(originalBlob);

            // Show in browser or download
            const modifiedUrl = URL.createObjectURL(modifiedBlob);

            setModifiedPdfUrl(modifiedUrl);

        } catch (error) {
            console.error('PDF generation failed:', error);
        } finally {
            setIsLoading(false);
        }

    };

    const handleModelapply = () => {
        const modelData = {
            ...examData,
            font_size: fontSize,
            heading_size: headingTextSize,
            watermark_size: watermarkItemSize,
            watermark_opacity: watermarkItemOpacity,
        };
        dispatch(setPaperData(modelData));
        setisModelOpen(!isModelOpen);
    };

    return (
        <div>

            {modifiedPdfUrl && (
                <div>

                    <div style={{ display: "flex", justifyContent: "center", width: "auto", alignContent: "center"}}>
                    <div style={{ position: "fixed", bottom: "5%", right: "5%", zIndex: 999 }}>
                                <div >
                                    <button
                                        onClick={handleEdit}
                                        className="w-full bg-blue-600 text-white py-3 px-4 rounded-full shadow-md hover:bg-blue-700 transition-all"
                                    >
                                        Edit
                                    </button>
                                </div>
                            </div>
                        {isLoading && <Loading />}
                        <iframe src={modifiedPdfUrl} style={{ width: "100%", height: "100vh" }} />

                    </div>
                </div>
            )}

            <CustomModal
                title="Edit Paper"
                buttonText="Apply"
                width="max-w-2xl"
                modalOpen={isModelOpen}
                onApply={handleModelapply}
                onClose={handleModelClose}
            >
                <EditModel
                    fontSize={fontSize}
                    setFontSize={setFontSize}
                    headingTextSize={headingTextSize}
                    setHeadingTextSize={setHeadingTextSize}
                    watermarkSize={watermarkItemSize}
                    setWatermarkSize={setWatermarkItemSize}
                    watermarkOpacity={watermarkItemOpacity}
                    setWatermarkOpacity={setWatermarkItemOpacity}
                />
            </CustomModal>
        </div>
    );
};

export default PdfPreview;
